module.exports = __webpack_public_path__ + "img/nousomni2.74db25d0.jpg";